import { Capacitor } from '@capacitor/core'
import { env } from '../config/env'

/** True when running inside a Capacitor native shell (iOS or Android). */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform()
}

/** Which native shell we run in, or 'web' for any browser. */
export function getNativePlatform(): 'ios' | 'android' | 'web' {
  const platform = Capacitor.getPlatform()
  return platform === 'ios' || platform === 'android' ? platform : 'web'
}

/**
 * True for a web browser running on a phone/tablet (touch + mobile UA).
 * Native shells are excluded — use {@link isNativeApp} for those.
 */
export function isMobileWeb(): boolean {
  if (isNativeApp()) return false
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return false
  const ua = navigator.userAgent || ''
  const touch = (navigator.maxTouchPoints ?? 0) > 0 || 'ontouchstart' in window
  const mobileUa = /Android|iPhone|iPad|iPod|Mobile|Windows Phone|BlackBerry|IEMobile|Opera Mini/i.test(ua)
  // iPadOS 13+ masquerades as desktop Safari — detect via touch points.
  const iPadOs = /Macintosh/.test(ua) && (navigator.maxTouchPoints ?? 0) > 1
  return (mobileUa || iPadOs) && touch
}

/** True for a web browser running on a desktop/laptop (no native shell, not mobile). */
export function isDesktopWeb(): boolean {
  return !isNativeApp() && !isMobileWeb()
}

/** True when native push is opted in and the Android build includes FCM config. */
export function isNativePushEnabled(): boolean {
  if (!env.enablePush) return false
  return typeof __NATIVE_PUSH_ENABLED__ !== 'undefined' && __NATIVE_PUSH_ENABLED__
}
